import { postWithCsrf } from 'src/auth';

/**
 * Just does a POST fetch, but handles CSRF token (with one stale-token retry).
 */
export async function postFetch<T extends Record<string, unknown>>(url: string, body: T) {
  return postWithCsrf(url, {
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
